import { Employment, EmploymentStatusEnum } from '../../models/employment';
import { EmploymentInvitee } from '../../models/employmentInvitee';
import { EmploymentInviteeStatusEnum } from '../../models/employmentInviteeStatusEnum';
import { Invitee } from '../../models/invitee';
import { Job } from '../../models/job';
import { InviteeStatusEnum } from '../../models/jobInviteeStatusEnum';
import { JobStatusEnum } from '../../models/jobStatusEnum';

export function filterOverviewInvitees(job: Job): Invitee[] {
  let statusShownInOverview =
    job?.status === JobStatusEnum.OPEN
      ? [
          InviteeStatusEnum.AVAILABLE,
          InviteeStatusEnum.PARTIAL_AVAILABLE,
          InviteeStatusEnum.POSSIBLE_CANDIDATE,
          // for jobs that require multiple users, we show the booked ones as well
          InviteeStatusEnum.BOOKED,
          InviteeStatusEnum.CANCELED,
          InviteeStatusEnum.TRANSFERRED,
        ]
      : [
          InviteeStatusEnum.BOOKED,
          InviteeStatusEnum.CANCELED,
          InviteeStatusEnum.TRANSFERRED,
        ];
  return job.invitees.filter((invitee) =>
    statusShownInOverview.includes(invitee.status),
  );
}

export function filterMultidayOverviewInvitees(job: Job): Invitee[] {
  let statusShownInOverview =
    job?.status === JobStatusEnum.OPEN
      ? [
          InviteeStatusEnum.OPEN,
          InviteeStatusEnum.AVAILABLE,
          InviteeStatusEnum.PARTIAL_AVAILABLE,
          InviteeStatusEnum.POSSIBLE_CANDIDATE,
          // for jobs that require multiple users, we show the booked ones as well
          InviteeStatusEnum.BOOKED,
          InviteeStatusEnum.CANCELED,
          InviteeStatusEnum.TRANSFERRED,
        ]
      : [
          InviteeStatusEnum.BOOKED,
          InviteeStatusEnum.CANCELED,
          InviteeStatusEnum.TRANSFERRED,
        ];
  return job.invitees.filter((invitee) =>
    statusShownInOverview.includes(invitee.status),
  );
}

export function filterOverviewInviteesForEmployment(
  employment: Employment,
): EmploymentInvitee[] {
  let statusShownInOverview =
    employment?.status === EmploymentStatusEnum.OPEN
      ? [
          EmploymentInviteeStatusEnum.AVAILABLE,
          EmploymentInviteeStatusEnum.POSSIBLE_CANDIDATE,
          EmploymentInviteeStatusEnum.BOOKED,
          EmploymentInviteeStatusEnum.CANCELLED,
        ]
      : [
          EmploymentInviteeStatusEnum.BOOKED,
          EmploymentInviteeStatusEnum.CANCELLED,
        ];
  return employment.invitees.filter((invitee) => {
    return statusShownInOverview.includes(invitee.status);
  });
}
